import React from 'react';
import { formatSeconds } from '@playbookux/playbook-web-core';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import _ from 'lodash';

import {
  Container,
  Title,
  Text,
} from './styles';

// eslint-disable-next-line react/jsx-props-no-spreading
const renderComponentToHTML = (props) => ReactDOMServer.renderToString(<MarkerTipComponent {...props} />);

const MarkerTipComponent = ({
  questionType, videoStartTime, label, isMarker,
}) => {
  if (isMarker) {
    return (
      <Container>
        <Title>
          {`${_.startCase(questionType)} (${formatSeconds(videoStartTime)})`}
        </Title>
        <Text>{label}</Text>
      </Container>
    );
  }
  return null;
};

MarkerTipComponent.propTypes = {
  questionType: PropTypes.string,
  videoStartTime: PropTypes.number,
  label: PropTypes.string,
  isMarker: PropTypes.bool.isRequired,
};

MarkerTipComponent.defaultProps = {
  questionType: '',
  videoStartTime: 0,
  label: '',
};

export default renderComponentToHTML;
